
import { Component, Vue, Prop } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnMap } from "@/models/api/asn/map";

const asnModule = getModule(AsnModule);

@Component
export default class EditMapModal extends Vue {

    @Prop({ default: null })
    AsnMap: AsnMap

    displayName: string = '';

    json: string = null;

    async onCancel(){
        this.$emit('edit-cancel');
    }

    async onSave(){
        let result = await asnModule.updateMap({ id: this.AsnMap.id, displayName: this.displayName, asnLevel: this.AsnMap.asnLevel, json: this.AsnMap.json });
        this.$emit('edit-save', result);
    }

    created(){
        this.displayName = this.AsnMap.displayName;
        this.json = this.AsnMap.json;
    }
}

